// extracted by mini-css-extract-plugin
export var divider = "_lq-0";
export var systemMessage = "_lq-1";
export var systemMessageWrapper = "_lq-2";